export default function Icon1_2() {
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_3884_40298)">
                <circle cx="20" cy="20" r="16.25" stroke="#26AC04" strokeWidth="2.5" />
                <path d="M11.5 11L12.2672 13.7328L15 14.5L12.2672 15.2672L11.5 18L10.7328 15.2672L8 14.5L10.7328 13.7328L11.5 11Z" fill="#26AC04" />
                <path d="M28.5 21L29.048 22.952L31 23.5L29.048 24.048L28.5 26L27.952 24.048L26 23.5L27.952 22.952L28.5 21Z" fill="#26AC04" />
                <path d="M16.8235 11L14 21L18.9412 21.7692L16.8235 31L26 19.4616L20.353 17.923L24.5882 11H16.8235Z" fill="#26AC04" />
            </g>
            <defs>
                <clipPath id="clip0_3884_40298">
                    <rect width="40" height="40" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
